import moment from 'moment-timezone';

export class TimeHelper {
  static readonly HOUR = 3600000;
  static readonly MINUTE = 60000;
  static readonly DEFAULT_TIMEZONE = 'America/New_York';

  private static parseTimeString(timeString: string | null): moment.Moment | null {
    if (!timeString) {
      return null;
    }

    const [hours, minutes] = timeString.split(':').map(num => parseInt(num, 10));
    return moment({
      hours,
      minutes,
      seconds: 0,
      milliseconds: 0,
    });
  }

  static getDateInFormatWithTimezone(
    date: Date,
    format: string,
    timezone: string = this.DEFAULT_TIMEZONE
  ): string {
    return moment(date)
      .tz(timezone || this.DEFAULT_TIMEZONE)
      .format(format);
  }

  static isWithinTimeFrame(startTimeString: string | null, endTimeString: string | null): boolean {
    const now = moment();
    const startTime = this.parseTimeString(startTimeString);
    const endTime = this.parseTimeString(endTimeString);

    if (startTime && now.isBefore(startTime)) {
      return false;
    }

    if (endTime && now.isAfter(endTime)) {
      return false;
    }

    return true;
  }
}
